export const WHY_PERCEPTICA_DESCRIPTION_BG =
  "Perceptica свързва медиен мониторинг, MLP платформа и експертен медиен анализ, за да превръща отразяването в ясни решения за екипите в Югоизточна Европа.";
